import { MediaTypes } from "@coworker/app/src/components/RoomSettings/constants";
import { getMediaTypeText } from "@coworker/app/src/components/RoomSettings/tools";

const MEDIA_TYPE_ALIASES: Record<string, string> = {
  ROOM_SETTINGS: "ROOM_SETTING",
};

export const normalizeMediaType = (mediaType: string) => {
  const normalized = mediaType
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_|_$/g, "")
    .toUpperCase();

  return MEDIA_TYPE_ALIASES[normalized] ?? normalized;
};

export const getMediaTypeLabel = (normalizedMediaType: string) => {
  // The backend alias normalises to ROOM_SETTING while the enum uses ROOM_SETTINGS.
  const key =
    normalizedMediaType === "ROOM_SETTING"
      ? "ROOM_SETTINGS"
      : normalizedMediaType;
  const known = Object.values(MediaTypes).includes(key as MediaTypes);
  const text = known ? getMediaTypeText(key as MediaTypes) : "";
  if (text) return text;
  const lower = normalizedMediaType.replace(/_/g, " ").toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
};
